var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-discord",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.257 7.847c-1.726-0.759-3.572-1.31-5.502-1.624-0.237 0.403-0.514 0.944-0.705 1.375-2.051-0.29-4.084-0.29-6.097 0-0.191-0.431-0.474-0.972-0.713-1.375-1.932 0.314-3.78 0.867-5.506 1.628-3.482 4.943-4.426 9.763-3.954 14.515 2.309 1.62 4.547 2.604 6.747 3.248 0.543-0.702 1.028-1.449 1.445-2.236-0.795-0.284-1.556-0.634-2.276-1.041 0.191-0.133 0.378-0.272 0.558-0.415 4.388 1.928 9.155 1.928 13.491 0 0.182 0.143 0.369 0.282 0.558 0.415-0.721 0.409-1.485 0.759-2.28 1.043 0.417 0.785 0.9 1.534 1.445 2.236 2.202-0.644 4.442-1.628 6.752-3.25 0.554-5.509-0.946-10.285-3.964-14.519zM11.572 19.444c-1.317 0-2.397-1.155-2.397-2.562s1.057-2.564 2.397-2.564 2.42 1.155 2.397 2.564c0.002 1.407-1.057 2.562-2.397 2.562zM20.431 19.444c-1.317 0-2.397-1.155-2.397-2.562s1.057-2.564 2.397-2.564 2.42 1.155 2.397 2.564c0 1.407-1.057 2.562-2.397 2.562z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-twitter",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.044 13.543l11.913-13.543h-2.823l-10.344 11.759-8.262-11.759h-9.529l12.493 17.782-12.493 14.202h2.823l10.923-12.418 8.725 12.418h9.529l-12.956-18.441zM15.178 17.938l-11.337-15.86h4.336l19.959 27.921h-4.336l-8.622-12.061z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ship",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.14 0.001c-8.947-0.074-16.213 7.192-16.139 16.139 0.075 8.688 7.173 15.787 15.859 15.859 8.947 0.077 16.216-7.192 16.139-16.139-0.072-8.685-7.171-15.784-15.859-15.859zM11.356 7.964c1.024 1.301 1.637 2.947 1.637 4.733 0 1.547-0.459 2.987-1.248 4.189h-5.547l5.158-8.922zM28.268 17.711v1.152c0 0.075-0.040 0.139-0.109 0.168-0.376 0.16-1.616 0.736-2.133 1.453-1.331 1.853-2.347 4.765-4.619 4.765h-9.48c-3.357 0-6.165-2.664-6.163-6.213 0-0.088 0.075-0.16 0.163-0.16h4.493c0.155 0 0.277 0.125 0.277 0.277v0.867c0 0.461 0.373 0.835 0.835 0.835h3.408v-1.984h-2.328c1.339-1.696 2.136-3.837 2.136-6.168 0-2.6-0.997-4.971-2.629-6.744 0.987 0.115 1.931 0.312 2.821 0.573v-0.552c0-0.573 0.464-1.037 1.037-1.037s1.037 0.464 1.037 1.037v1.331c3.181 1.485 5.264 3.949 5.264 6.736 0 1.635-0.715 3.157-1.949 4.437-0.237 0.245-0.565 0.384-0.909 0.384h-2.405v1.981h3.019c0.651 0 1.819-1.235 2.373-1.979 0 0 0.024-0.037 0.088-0.056s5.544-1.277 5.544-1.277c0.115-0.032 0.229 0.056 0.229 0.173v0.002z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.778 9.636l-14.142 14.142-1.414-1.414 14.142-14.142 1.414 1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.636 8.222l14.142 14.142-1.414 1.414-14.142-14.142 1.414-1.414z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vector",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.946 0h28.054v28.054h-8.632v-13.318l-17.264 17.264-6.104-6.104 17.264-17.264h-13.318v-8.632z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-MetaMask",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5841f",
    style: {
      fill: "var(--color1, #f5841f)"
    },
    d: "M26.156 15.984l1.078-1.266-0.469-0.344 0.75-0.687-0.578-0.437 0.75-0.563-0.484-0.375 0.781-3.813-1.187-3.531zM26.797 4.969l-7.625 2.828h-6.359l-7.625-2.828-1.188 3.531 0.797 3.813-0.5 0.375 0.766 0.563-0.578 0.437 0.75 0.687-0.469 0.344 1.078 1.266-1.641 5.063 1.516 5.172 5.328-1.469 1.031 0.844 2.109 1.437h3.609l2.109-1.437 1.031-0.844 5.344 1.469 1.531-5.172-1.656-5.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M26.797 4.969l-9.359 6.891 1.734-4.063 7.625-2.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M5.188 4.969l9.281 6.953-1.656-4.125-7.625-2.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M23.437 20.953l-2.5 3.781 5.344 1.469 1.531-5.172-4.375-0.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M4.203 21.031l1.516 5.172 5.328-1.469-2.484-3.781-4.359 0.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M10.766 14.547l-1.484 2.234 5.281 0.234-0.172-5.656-3.625 3.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M21.234 14.547l-3.687-3.25-0.109 5.719 5.281-0.234-1.484-2.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M11.047 24.734l3.203-1.531-2.766-2.125-0.438 3.656z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M17.75 23.203l3.187 1.531-0.437-3.656-2.75 2.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7c1b3",
    style: {
      fill: "var(--color3, #d7c1b3)"
    },
    d: "M20.937 24.734l-3.187-1.531 0.266 2.063-0.031 0.875 2.953-1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7c1b3",
    style: {
      fill: "var(--color3, #d7c1b3)"
    },
    d: "M11.047 24.734l2.969 1.406-0.016-0.875 0.25-2.063-3.203 1.531z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f343b",
    style: {
      fill: "var(--color4, #2f343b)"
    },
    d: "M14.063 19.703l-2.641-0.766 1.875-0.859 0.766 1.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f343b",
    style: {
      fill: "var(--color4, #2f343b)"
    },
    d: "M17.922 19.703l0.781-1.625 1.875 0.859-2.656 0.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc6228",
    style: {
      fill: "var(--color5, #cc6228)"
    },
    d: "M11.047 24.734l0.469-3.781-2.953 0.078 2.484 3.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc6228",
    style: {
      fill: "var(--color5, #cc6228)"
    },
    d: "M20.484 20.953l0.453 3.781 2.5-3.703-2.953-0.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc6228",
    style: {
      fill: "var(--color5, #cc6228)"
    },
    d: "M22.719 16.781l-5.281 0.234 0.484 2.687 0.781-1.625 1.875 0.859 2.141-2.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc6228",
    style: {
      fill: "var(--color5, #cc6228)"
    },
    d: "M11.422 18.937l1.875-0.859 0.766 1.625 0.5-2.687-5.281-0.234 2.141 2.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M9.281 16.781l2.203 4.297-0.063-2.141-2.141-2.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M20.578 18.937l-0.078 2.141 2.219-4.297-2.141 2.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M14.563 17.016l-0.5 2.687 0.625 3.188 0.141-4.188-0.266-1.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    style: {
      fill: "var(--color2, #e27625)"
    },
    d: "M17.437 17.016l-0.266 1.672 0.125 4.203 0.625-3.188-0.484-2.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5841f",
    style: {
      fill: "var(--color1, #f5841f)"
    },
    d: "M17.922 19.703l-0.625 3.188 0.453 0.312 2.75-2.125 0.078-2.141-2.656 0.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5841f",
    style: {
      fill: "var(--color1, #f5841f)"
    },
    d: "M11.422 18.937l0.063 2.141 2.766 2.125 0.437-0.312-0.625-3.188-2.641-0.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c0ad9e",
    style: {
      fill: "var(--color6, #c0ad9e)"
    },
    d: "M17.984 26.141l0.031-0.875-0.25-0.203h-3.547l-0.219 0.203 0.016 0.875-2.969-1.406 1.031 0.844 2.109 1.453h3.609l2.109-1.453 1.031-0.844-2.953 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f343b",
    style: {
      fill: "var(--color4, #2f343b)"
    },
    d: "M17.75 23.203l-0.453-0.312h-2.609l-0.437 0.312-0.25 2.063 0.219-0.203h3.547l0.25 0.203-0.266-2.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763e1a",
    style: {
      fill: "var(--color7, #763e1a)"
    },
    d: "M27.203 12.313l0.781-3.813-1.187-3.531-9.047 6.656 3.484 2.922 4.922 1.437 1.078-1.266-0.469-0.344 0.75-0.672-0.578-0.453 0.75-0.563-0.484-0.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763e1a",
    style: {
      fill: "var(--color7, #763e1a)"
    },
    d: "M4 8.5l0.797 3.813-0.5 0.375 0.75 0.578-0.578 0.437 0.75 0.672-0.469 0.344 1.094 1.266 4.922-1.437 3.484-2.922-9.063-6.656-1.188 3.531z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5841f",
    style: {
      fill: "var(--color1, #f5841f)"
    },
    d: "M26.156 15.984l-4.922-1.437 1.484 2.234-2.219 4.297 2.937-0.047h4.375l-1.656-5.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5841f",
    style: {
      fill: "var(--color1, #f5841f)"
    },
    d: "M10.766 14.547l-4.922 1.437-1.641 5.047h4.359l2.922 0.047-2.203-4.297 1.484-2.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5841f",
    style: {
      fill: "var(--color1, #f5841f)"
    },
    d: "M17.437 17.016l0.313-5.391 1.422-3.828h-6.359l1.438 3.828 0.313 5.391 0.125 1.687v4.188h2.609l0.016-4.188 0.125-1.687z"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 48 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.352 23.381h3.148c1.861 0 3.024 0.828 3.012 2.096-0.005 0.546 0 1.227-0.706 1.85 0.489 0 1.050 0.664 1.050 1.98 0 1.674-0.978 2.57-2.514 2.57h-3.989v-8.497zM2.283 25.201v1.543h1.524c0.564 0 0.699-0.476 0.699-0.724v-0.059c0-0.484-0.19-0.736-0.699-0.736l-1.524-0.024zM2.283 28.35v1.825h1.788c0.427 0 0.589-0.437 0.589-0.823v-0.127c0-0.583-0.277-0.864-0.788-0.864l-1.588-0.011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.077 28.103l-2.922-4.72h2.541l1.41 2.769 1.55-2.769h2.312l-2.834 4.72v3.776h-2.058v-3.776z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.968 26.128c0 1.716-1.367 3.096-4.35 3.096v2.652h-2.085v-8.481h3.166c2.446 0 3.269 1.018 3.269 2.733zM24.618 27.639h0.727c0.938 0 1.674-0.524 1.674-1.512s-0.598-1.257-1.674-1.257h-0.727v2.768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.352 22.237v-11.12h2.948l3.379 5.949 3.563-5.949h2.948v11.12h-2.948v-5.080l-3.563 5.080-3.379-5.080v5.080h-2.948z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.816 11.117h4.012l2.927 11.12h-2.605l-0.685-2.068h-3.378l-0.634 2.068h-2.657l3.020-11.12zM18.823 14.052l-1.327 4.072h2.557l-1.23-4.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.082 11.118h8.266v2.513h-5.634v1.75h5.634v2.45h-5.634v2.084h5.634v2.322h-8.266v-11.119z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.428 23.395h6.305v1.917h-4.297v1.335h4.297v1.869h-4.297v1.59h4.297v1.771h-6.305v-8.481z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.778 23.395h3.060l2.233 8.481h-1.987l-0.523-1.577h-2.577l-0.484 1.577h-2.027l2.304-8.481zM18.309 25.633l-1.012 3.105h1.951l-0.938-3.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.080 22.252l-3.752-0.010v-11.12l3.752-0.035c3.515 0 5.393 1.633 5.393 5.666 0 3.094-1.802 5.498-5.393 5.498zM26.911 19.848h1.169c1.641 0 2.642-1.002 2.642-3.094s-0.781-3.067-2.642-3.067h-1.169v6.161z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.482 25.751c0-1.323 0.988-2.284 2.586-2.415 1.334-0.11 2.549 0.354 3.471 0.941l-0.842 1.797c0 0-0.943-0.524-1.497-0.692-0.435-0.132-1.013-0.008-1.132 0.275s-0.097 0.572 0.287 0.757c0.031 0.015 0.065 0.031 0.102 0.049 0.212 0.101 0.532 0.253 0.895 0.465h0.006c0 0 0.78 0.402 1.389 1.049 0.049 0.049 0.099 0.1 0.146 0.151h-0.010c0.326 0.386 0.575 0.846 0.575 1.351 0 1.322-1.139 2.375-2.737 2.506-1.334 0.109-2.553-0.474-3.475-1.061l0.651-1.8c0 0 1.289 0.555 1.842 0.724 0.435 0.132 1.013 0.008 1.132-0.275s0.134-0.484-0.287-0.757c-0.131-0.085-0.289-0.173-0.467-0.273-0.133-0.074-0.277-0.155-0.431-0.246-0.167-0.084-2.207-1.139-2.207-2.547h0.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.857 12.942v-1.854h0.463l0.578 0.992 0.552-0.992h0.549v1.854h-0.463v-0.915l-0.638 0.915-0.549-0.915v0.915h-0.492z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.928 11.478v-0.39h1.756v0.39h-0.64v1.464h-0.47v-1.464h-0.646z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.971 0.854l-0.996-0.158c-0.058-0.009-0.068-0.081-0.014-0.103 2.314-0.944 4.754-0.557 6.533 0.925 0.063 0.053 0.047 0.149-0.029 0.185-0.32 0.157-0.676 0.384-0.835 0.49-0.049 0.033-0.116 0.027-0.16-0.012-1.14-1.013-3.248-1.151-4.499-1.328v0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.728 0.854l0.996-0.158c0.058-0.009 0.068-0.081 0.014-0.103-2.315-0.944-4.755-0.557-6.533 0.925-0.063 0.053-0.047 0.149 0.029 0.185 0.32 0.157 0.676 0.384 0.835 0.49 0.049 0.033 0.116 0.027 0.16-0.012 1.14-1.013 3.248-1.151 4.499-1.328v0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.408 1.668c-1.6 0-2.495-0.377-4.069-0.399-0.053-0.001-0.079-0.060-0.040-0.093 1.123-0.954 3.287-1.176 4.040-1.176 0.632 0 2.728 0.176 3.947 1.169 0.041 0.034 0.014 0.095-0.041 0.094-1.579-0.024-1.59 0.404-3.836 0.404l0.001 0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57 9.457h-0.974c-0.17 0-0.288-0.16-0.23-0.309 0.107-0.275 0.246-0.667 0.265-0.894 0.017-0.216 0.010-0.396 0.002-0.558-0.014-0.328-0.026-0.588 0.18-0.951 0.169-0.298 0.356-0.537 0.547-0.78 0.239-0.305 0.483-0.617 0.705-1.063 0.169-0.34 0.278-0.824 0.395-1.342 0.108-0.477 0.222-0.983 0.395-1.432 0.362-0.934 0.49-1.267 1.374-1.406 0.864-0.136 1.851 0.126 2.853 0.393 0.574 0.153 1.154 0.307 1.717 0.387 0.355 0.051 0.716 0.095 1.073 0.139 1.501 0.184 2.965 0.364 3.884 1.021 0.109 0.078 0.109 0.226 0.027 0.329-0.344 0.429-0.631 1.193-0.685 2.112-0.040 0.66 0.128 1.482 0.438 2.498 0.178 0.586-0.138 1.22-0.348 1.641-0.014 0.027-0.027 0.053-0.039 0.079-0.040 0.082-0.128 0.136-0.225 0.136h-7.494c-0.133 0-0.24-0.1-0.246-0.223-0.053-1.052-0.488-2.15-1.609-2.15s-1.623 1.31-1.759 2.171c-0.018 0.114-0.121 0.202-0.245 0.202v-0.001zM3.465 5.795v-0.001c0.411 0.412 1.917 0.6 2.734-0.203 0.955-0.938 1.019-2.912 0.060-3.442-0.38-0.21-1.040-0.263-1.040-0.263-0.958 0-1.154 0.726-1.362 1.494-0.053 0.195-0.107 0.393-0.173 0.583-0.061 0.174-0.145 0.338-0.226 0.496-0.237 0.466-0.449 0.881 0.007 1.336zM8.289 6.864c0.917 0.622 2.393 0.458 3.036-0.023 0.846-0.633 1.034-2.752 0.317-3.37-0.774-0.667-1.616-0.74-2.524-0.336-1.027 0.457-1.469 3.297-0.829 3.73h0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.128 9.457h0.973c0.17 0 0.288-0.16 0.23-0.309-0.107-0.275-0.247-0.667-0.265-0.894-0.017-0.216-0.010-0.396-0.002-0.558 0.014-0.328 0.026-0.588-0.18-0.951-0.169-0.298-0.356-0.537-0.547-0.78-0.239-0.305-0.483-0.617-0.705-1.063-0.169-0.34-0.278-0.824-0.395-1.342-0.108-0.477-0.222-0.983-0.395-1.432-0.362-0.934-0.49-1.267-1.374-1.406-0.864-0.136-1.851 0.126-2.852 0.393-0.574 0.153-1.154 0.307-1.718 0.387-0.355 0.051-0.716 0.095-1.074 0.139-1.502 0.184-2.965 0.364-3.884 1.021-0.109 0.078-0.109 0.226-0.026 0.329 0.344 0.429 0.631 1.193 0.685 2.112 0.040 0.66-0.128 1.482-0.438 2.498-0.162 0.532 0.083 1.102 0.287 1.517 0.101 0.205 0.324 0.338 0.566 0.338h7.254c0.133 0 0.24-0.1 0.246-0.223 0.053-1.052 0.488-2.15 1.609-2.15s1.623 1.31 1.759 2.171c0.018 0.114 0.121 0.202 0.245 0.202v-0.001zM39.234 5.795v-0.001c-0.411 0.412-1.916 0.6-2.735-0.203-0.955-0.938-1.019-2.912-0.060-3.442 0.38-0.21 1.040-0.263 1.040-0.263 0.958 0 1.154 0.726 1.362 1.494 0.053 0.195 0.107 0.393 0.173 0.583 0.062 0.174 0.145 0.338 0.226 0.496 0.237 0.466 0.449 0.881-0.007 1.336zM34.41 6.864c-0.917 0.622-2.393 0.458-3.036-0.023-0.846-0.633-1.034-2.752-0.317-3.37 0.774-0.667 1.616-0.74 2.524-0.336 1.028 0.457 1.469 3.297 0.829 3.73h-0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.937 9.457v0.001c0.109 0 0.205-0.068 0.241-0.164 0.176-0.469 0.79-1.786 2.15-1.786s1.974 1.317 2.149 1.786c0.036 0.096 0.131 0.164 0.241 0.164h4.894c0.097 0 0.154-0.103 0.102-0.179-0.622-0.919-0.471-1.524-0.269-2.329 0.142-0.564 0.308-1.226 0.249-2.162-0.089-1.406-0.95-2.291-2.561-2.616-0.837-0.168-1.918-0.010-2.932 0.139-0.645 0.095-1.263 0.185-1.774 0.185-0.686 0-1.394-0.109-2.085-0.215-0.999-0.154-1.962-0.303-2.772-0.109-1.561 0.373-2.334 1.149-2.62 2.698-0.107 0.804 0.071 1.416 0.236 1.985 0.223 0.768 0.422 1.456-0.133 2.432-0.043 0.076 0.014 0.171 0.108 0.171h4.777zM18.238 7.263c-0.957 0.522-2.201 0.514-2.683-0.517-0.548-1.172-0.015-2.829 1.527-3.239 1.615-0.429 3.178-0.22 3.12 0.911-0.044 0.84-0.845 2.235-1.963 2.845v0.001zM27.176 6.745c-0.482 1.032-1.727 1.039-2.683 0.517-1.118-0.61-1.919-2.005-1.963-2.845-0.059-1.13 1.504-1.34 3.12-0.911 1.542 0.41 2.074 2.067 1.527 3.239v-0.001z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.809f6da79e2342aebfc25c7d0ad83efa.svg";
export { ForwardRef as ReactComponent };